import { Button, Card } from "@endya-conformite/ui-kit";
import { handleGatewayError } from "@src/api/utils/handleGatewayError";
import { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import Loader from "@endya-conformite/ui-kit/src/assets/loader.svg?react";
import XCircle from "@endya-conformite/ui-kit/src/assets/icons/x-circle.svg?react";
import { useStore } from "@src/store/store.hooks";
import { GatewayAdminApi } from "@src/api/admin.api";
import styles from "./AdminSwitchSession.module.scss";

export function AdminSwitchSession() {
  const { contactId, entreprisePrincipalId } = useParams<{
    contactId: string;
    entreprisePrincipalId: string;
  }>();
  const [searchParams] = useSearchParams();
  const requestedRedirect = searchParams.get("redirectTo");
  const redirectTo =
    requestedRedirect && requestedRedirect.startsWith("/")
      ? requestedRedirect
      : "/";
  const [status, setStatus] = useState<"idle" | "error">("idle");
  const navigate = useNavigate();
  const {
    refresh: { increaseRefreshCount },
  } = useStore();
  useEffect(() => {
    if (!contactId || !entreprisePrincipalId) {
      setStatus("error");
      return;
    }
    GatewayAdminApi.isAdmin()
      .then(() => {
        localStorage.setItem("adminContactId", contactId);
        localStorage.setItem(
          "adminEntreprisePrincipalId",
          entreprisePrincipalId
        );
        increaseRefreshCount();
        navigate(redirectTo);
      })
      .catch((error) => {
        console.error(error);
        handleGatewayError({
          onUnhandled: () => {
            setStatus("error");
          },
        })(error);
      });
  }, [
    contactId,
    entreprisePrincipalId,
    navigate,
    increaseRefreshCount,
    redirectTo,
  ]);
  if (status === "idle") {
    return <Loader />;
  }
  return (
    <Card className={styles.card}>
      {status === "error" && (
        <>
          <div className={styles.header}>
            <XCircle className={styles.icon} />
            <h1>Attention</h1>
          </div>
          <p>
            Vous n&apos;avez pas les droits d&apos;accéder à cette
            fonctionnalité.
          </p>
        </>
      )}
      <Button
        onClick={() => {
          window.close();
        }}
      >
        Fermer la page
      </Button>
    </Card>
  );
}
